var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewAltTrash = function SvgNewAltTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.807,
    height: 45.658,
    viewBox: "0 0 26.807 45.658",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7941",
    "data-name": "Grupo 7941",
    transform: "translate(-248.117 -286.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3065",
    "data-name": "Caminho 3065",
    d: "M251.6,296.346l1.436,23.259h9.214",
    transform: "translate(-0.73 -2.665)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_174",
    "data-name": "Linha 174",
    x2: 12.403,
    transform: "translate(249.117 290.187)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_175",
    "data-name": "Linha 175",
    y2: 16.64,
    transform: "translate(261.52 296.262)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_176",
    "data-name": "Linha 176",
    x1: 1.11,
    y1: 16.64,
    transform: "translate(256.195 296.262)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3066",
    "data-name": "Caminho 3066",
    d: "M261.839,290.187v-2.905h3.423",
    transform: "translate(-3.741)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3067",
    "data-name": "Caminho 3067",
    d: "M277.337,296.346,275.9,319.605h-9.214",
    transform: "translate(-5.167 -2.665)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_177",
    "data-name": "Linha 177",
    x1: 12.403,
    transform: "translate(261.52 290.187)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_178",
    "data-name": "Linha 178",
    y1: 16.64,
    x2: 1.11,
    transform: "translate(265.736 296.262)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3068",
    "data-name": "Caminho 3068",
    d: "M270.11,290.187v-2.905h-3.423",
    transform: "translate(-5.167)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    style: {
      isolation: "isolate"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewAltTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_alt_trash.2ab77bd0.svg";
export { ForwardRef as ReactComponent };